var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "apple_svg__pbs-apple",
    viewBox: "0 0 29.44 32.52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.62 29h.11c1.76-.08 2.41-1.13 4.53-1.13S18 29 19.8 29s3.07-1.7 4.2-3.4a14.2 14.2 0 0 0 1.93-3.93 6.08 6.08 0 0 1-3.7-5.67 6.3 6.3 0 0 1 3-5.28A6.38 6.38 0 0 0 20.16 8C18 7.78 16 9.28 14.9 9.28S12.13 8 10.33 8.06a6.73 6.73 0 0 0-5.66 3.47 9.57 9.57 0 0 0-1.16 4.79 17.3 17.3 0 0 0 2.89 9.16C7.54 27.13 8.88 29 10.62 29",
    className: "apple_svg__cls-2",
    "data-name": "path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.18 6.17A4 4 0 0 1 14 7.68a4.53 4.53 0 0 1 1.12-3.31 4.88 4.88 0 0 1 3.14-1.64 4.82 4.82 0 0 1-1.08 3.44",
    className: "apple_svg__cls-2",
    "data-name": "path-3"
  })));
};
export default SvgApple;